"use client";

import { usePathname } from "next/navigation";
import { ThemeName, THEME_HEX } from "./theme";

const HEADING_CLASS = "font-crimsonText text-[20px] font-bold mb-3";
const ADDRESS_CLASS = "font-onest text-[16px] font-normal not-italic leading-[1.6]";
const SUBLABEL_CLASS = "font-onest text-[14px] font-semibold";

const COUNSELLING_PATHS = [
  "/counselling",
  "/anger-management",
  "/relationships",
  "/depression-anxiety",
  "/grief-loss",
  "/career-counselling",
  "/life-coach",
  "/self-esteem-confidence",
  "/time-management",
  "/focus-productivity",
  "/changing-habits",
  "/public-speaking",
];

const ALLIED_HEALTH_PATHS = ["/allied-health", "/occupational-therapy", "/psychology"];

const matches = (paths: string[], pathname: string) =>
  paths.some((p) => pathname === p || pathname.startsWith(p + "/"));

export default function FooterAddress({ theme = "blue" }: { theme?: ThemeName }) {
  const pathname = usePathname();
  const color = THEME_HEX[theme];

  const isCounsellingPage = matches(COUNSELLING_PATHS, pathname);
  const isAlliedHealthPage = matches(ALLIED_HEALTH_PATHS, pathname);

  // On a specific service page show only that service's address; everywhere else show both.
  const showCounselling = !isAlliedHealthPage;
  const showAlliedHealth = !isCounsellingPage;
  const showLabels = showCounselling && showAlliedHealth;

  return (
    <div className="flex flex-col gap-1">
      <span className={HEADING_CLASS} style={{ color }}>
        Location
      </span>

      {showCounselling && (
        <address className={ADDRESS_CLASS} style={{ color }}>
          {showLabels && (
            <>
              <span className={SUBLABEL_CLASS}>Counselling &amp; Life Coach</span>
              <br />
            </>
          )}
          <a
            href="https://maps.app.goo.gl/aJ1h9VTjYA5fxavb8"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Suite 207a, 30 Campbell St
            <br />
            Blacktown, NSW 2148, Australia
          </a>
        </address>
      )}

      {showAlliedHealth && (
        <address
          className={`${ADDRESS_CLASS} ${showLabels ? "mt-3" : ""}`}
          style={{ color }}
        >
          {showLabels && (
            <>
              <span className={SUBLABEL_CLASS}>Allied Health</span>
              <br />
            </>
          )}
          <a
            href="https://maps.app.goo.gl/9Z4jpyaDuSZKzyX6A"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Suite 15.01, Level 15, 60 Station St East
            <br />
            Parramatta NSW 2150
          </a>
        </address>
      )}
    </div>
  );
}
